import React, { useEffect, useState } from "react";
import {
    Button,
    FormHelperText,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from "@material-ui/core";
import ElementCategorySelect from "../../_shared/ElementCategorySelect";
import ElementNameSelect from "../../_shared/ElementNameSelect";
import GSDCodeSelect from "../../_shared/GSDCodeSelect";
import OperationSelect from "../../_shared/OperationSelect";
import PropTypes from "prop-types";
import { APP_TABLE_SETTINGS } from "../../../_constants";
import TablePaginationActions from "../../_shared/TablePaginationAction";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import FormControlWrapper from "../../_shared/FormControlWrapper";
import styles from './PreStudyActivityDetail.module.scss'
import { utilFunctions } from "../../../_helpers";

const PreStudyActivityDetail = (props) => {

    var INITIAL_STUDY_DETAILS = {
        isAnyRecordEdited: false,
        studyActivityDetails: [{
            inEditMode: false
            , showCancelButton: false
            , showSaveButton: true
            , showDeleteButton: false
            , showEditButton: true
            , sequenceNo: 0
            , gsdCode: { value: '', validator: 'text', isRequired: false, error: null, disable: false }
            , operation: { value: '', validator: 'text', isRequired: true, error: null, disable: false }
            , elementCategory: { value: '', validator: 'text', isRequired: false, error: null, disable: false }
            , element: { value: '', validator: 'text', isRequired: false, error: null, disable: false }
            , elementSubDescription: { value: '', validator: 'text', isRequired: false, error: null, disable: false }
            , gsdValue: { value: 0, validator: 'text', isRequired: false, error: null, disable: false }
            , id: { value: -1, validator: 'text', isRequired: false, error: null, disable: false }
            , studyPreActivityHeaderId: { value: -1, validator: 'number', isRequired: false, error: null, disable: false }
        }],
        page: 0,
        rowsPerPage: APP_TABLE_SETTINGS.DEFAULT_TABLE_PAGE_SIZE,
        filteredElementNames: [[]],
        filteredOperations: [[]]
    };
    var INITIAL_DROPDOWN_DATA = {
        gsdCodes: [],
        operations: [],
        elementCategories: [],
        elementName: []
    };
    var { preStudyHeader, dropDownData } = props;
    const [detailPageState, setdetailPageState] = useState(INITIAL_STUDY_DETAILS);
    const [ddData, setddData] = useState(INITIAL_DROPDOWN_DATA);

    const getNewDefaultActivityElement = () => {
        return {
            inEditMode: true
            , showCancelButton: false
            , showSaveButton: false
            , showDeleteButton: false
            , showEditButton: false
            , sequenceNo: 0
            , gsdCode: { value: undefined, validator: 'text', isRequired: true, error: null, disable: false }
            , operation: { value: undefined, validator: 'text', isRequired: true, error: null, disable: false }
            , elementCategory: { value: undefined, validator: 'text', isRequired: true, error: null, disable: false }
            , element: { value: undefined, validator: 'text', isRequired: true, error: null, disable: false }
            , elementSubDescription: { value: undefined, validator: 'text', isRequired: false, error: null, disable: false }
            , gsdValue: { value: 0, validator: 'number', isRequired: true, error: null, disable: false }
            , id: { value: -1, validator: 'text', isRequired: false, error: null, disable: false }
            , studyPreActivityHeaderId: { value: -1, validator: 'number', isRequired: false, error: null, disable: false }
        };
    }

    useEffect(() => {

        setddData(
            {
                ...props.dropDownData
            })
    }, [props.dropDownData])

    useEffect(() => {
        let tablePage: 0;
        let details = [];
        let filteredElements;
        let filteredOps;
        if (props.preStudyHeader != undefined
            && props.studyPreActivityDetails != undefined
        ) {
            details = props.studyPreActivityDetails.map((x) => {
                return {
                    inEditMode: false
                    , showCancelButton: false
                    , showSaveButton: false
                    , showDeleteButton: true
                    , showEditButton: true
                    , sequenceNo: x.sequenceNo
                    , gsdCode: { value: x.gsdCode, validator: 'text', isRequired: true, error: null, disable: false }
                    , operation: { value: x.operationName, validator: 'text', isRequired: true, error: null, disable: false }
                    , elementCategory: { value: x.elementCategoryId, validator: 'text', isRequired: true, error: null, disable: false }
                    , element: { value: x.elementId, validator: 'text', isRequired: true, error: null, disable: false }
                    , elementSubDescription: { value: x.elementSubDescription, validator: 'text', isRequired: false, error: null, disable: false }
                    , gsdValue: { value: x.gsdValue, validator: 'number', isRequired: true, error: null, disable: false }
                    , id: { value: x.id == undefined ? 0 : x.id, validator: 'number', isRequired: false, error: null, disable: false }
                    , studyPreActivityHeaderId: { value: x.studyPreActivityHeaderId == undefined ? 0 : x.id, validator: 'number', isRequired: false, error: null, disable: false }
                }
            })
            if (props.studyPreActivityDetails.find(x => x.id == -1)?.id == undefined) {
                details.splice(0, 0, getNewDefaultActivityElement())
            }

            filteredElements = details.map(x => {
                let selectedElementCategory = props.dropDownData.elementCategories.find(eCat => eCat.id == x.elementCategory.value)?.name
                return [...props.dropDownData.elementName.filter(eName => eName.categoryName?.toUpperCase() == selectedElementCategory?.toUpperCase())]

            })

            filteredOps = details.map(x => {
                return [...props.dropDownData.operations.filter(op => op.gsdCode != null && op.gsdCode != undefined && op.gsdCode.trim() != '' && op.gsdCode?.toUpperCase() == x.gsdCode.value)]
            })

            if (!!details && details.length > 0) {
                tablePage = 0
            }
        }
        setdetailPageState({
            ...detailPageState
            , studyActivityDetails: details
            , page: tablePage
            , filteredElementNames: filteredElements
            , filteredOperations: filteredOps
        })
    }, [props.studyPreActivityDetails])

    // handle pagination page change event
    const handleChangePage = (event: unknown, newPage: number) => {
        setdetailPageState({
            ...detailPageState
            , page: newPage
        })
    };

    // handle pagination rows per page dropdown change event
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setdetailPageState({
            ...detailPageState
            , page: 0
            , rowsPerPage: +event.target.value
        })
    };

    const onEditButtonClick = (index: number) => {
        var element = detailPageState.studyActivityDetails[index];
        element.inEditMode = true;
        element.showCancelButton = true;
        element.showSaveButton = true;
        element.showDeleteButton = true;
        element.showEditButton = false;
        detailPageState.studyActivityDetails[index] = element

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails]
        });

        props.onEdit();
    }
    const onSaveButtonClick = async (index: number, modifiedElement: any) => {

        const [validatedData, isValid]: any = await validateStudyActivityDetails(detailPageState.studyActivityDetails.filter(x => x.id.value != -1 && x.studyPreActivityHeaderId.value != -1))
        validatedData.splice(0, 0, getNewDefaultActivityElement());

        if (isValid) {
            detailPageState.studyActivityDetails = validatedData;
            var element = detailPageState.studyActivityDetails[index];

            element.inEditMode = false;
            element.showCancelButton = false;
            element.showSaveButton = false;
            element.showEditButton = true;

            if (element.id.value != -1) {
                detailPageState.studyActivityDetails[index] = element;
            }
            // if user saves first default element
            else {
                element.id.value = 0;
                element.studyPreActivityHeaderId.value = preStudyHeader.id;
                detailPageState.studyActivityDetails.splice(1, 0, element)
                detailPageState.studyActivityDetails[0] = getNewDefaultActivityElement();
            }
        }
        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...validatedData],
            isAnyRecordEdited: true
        });
    }
    const onDeleteButtonClick = (index: number) => {
        var element = detailPageState.studyActivityDetails[index];
        element.inEditMode = false;
        element.showCancelButton = false;
        element.showSaveButton = false;
        element.showDeleteButton = false;
        element.showEditButton = false;
        detailPageState.studyActivityDetails.splice(index, 1)
        detailPageState.filteredElementNames.splice(index, 1);

        // update sequence no after an element is deleted
        detailPageState.studyActivityDetails = detailPageState.studyActivityDetails.map(x => {
            if (x.sequenceNo > element.sequenceNo) {
                x.sequenceNo -= 1
                return x;
            }
            return x;
        })
        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true
        });
    }

    const onAddClick = async () => {

        const [validatedData, isValid]: any = await validateStudyActivityDetails(detailPageState.studyActivityDetails)
        let isAnyRecordEdited = false;
        detailPageState.studyActivityDetails = validatedData;

        if (isValid) {
            let item = detailPageState.studyActivityDetails[0];
            item.id.value = 0;
            item.studyPreActivityHeaderId.value = preStudyHeader.id;
            item.showEditButton = true;
            item.showDeleteButton = true;
            item.showSaveButton = false;
            item.inEditMode = false;
            item.sequenceNo = (Math.max(...detailPageState.studyActivityDetails.map(x => x.sequenceNo))) + 1
            detailPageState.studyActivityDetails.splice(0, 1, item);
            detailPageState.studyActivityDetails.splice(0, 0, getNewDefaultActivityElement());

            let selectedElementCategory = dropDownData.elementCategories.find(x => x.id == item.elementCategory.value)?.name
            let filteredElementNamesForItem = dropDownData.elementName.filter(x => x.categoryName?.toUpperCase() == selectedElementCategory?.toUpperCase());
            detailPageState.filteredElementNames.splice(0, 1, filteredElementNamesForItem);
            detailPageState.filteredElementNames.splice(0, 0, []);
            let filteredOperationsForItem = dropDownData.operations.filter(x => x.gsdCode != null && x.gsdCode != undefined && x.gsdCode.trim() != '' && x.gsdCode?.toUpperCase() == item.gsdCode.value?.toUpperCase());
            detailPageState.filteredOperations.splice(0, 1, filteredOperationsForItem);
            detailPageState.filteredOperations.splice(0, 0, []);

            isAnyRecordEdited = true;

            props.onEdit();
        }
        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: isAnyRecordEdited,
            filteredElementNames: detailPageState.filteredElementNames,
            filteredOperations: detailPageState.filteredOperations
        });
    }

    const onSave = async () => {

        const [validatedData, isValid]: any = await validateStudyActivityDetails(detailPageState.studyActivityDetails.filter(x => x.id.value != -1));

        detailPageState.studyActivityDetails = validatedData;
        if (isValid) {
            props.onSave(detailPageState.studyActivityDetails
                .filter(x => x.id.value != -1 && x.studyPreActivityHeaderId.value != -1)
                .map(x => {
                    return {
                        id: x.id.value,
                        studyPreActivityHeaderId: x.studyPreActivityHeaderId.value,
                        gsdCode: x.gsdCode.value,
                        operationName: x.operation.value,
                        elementCategoryId: x.elementCategory.value,
                        elementId: x.element.value,
                        elementSubDescription: x.elementSubDescription.value,
                        gsdValue: (x.gsdValue.value == undefined || x.gsdValue.value == null || isNaN(x.gsdValue.value)) ? 0 : +x.gsdValue.value,
                        sequenceNo: x.sequenceNo
                    }
                })
            );
        }
        else {
            setdetailPageState({
                ...detailPageState,
                studyActivityDetails: [...detailPageState.studyActivityDetails]
            });
        }
    }

    const onGSDCodeChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        if (index != -1)
            element.gsdCode.value = newValue;
        element.gsdCode.error = null;
        detailPageState.studyActivityDetails[index] = element;

        let filteredOperationsForItem = dropDownData.operations.filter(x => x.gsdCode?.toUpperCase() == newValue.toUpperCase());
        detailPageState.filteredOperations[index] = filteredOperationsForItem;
        element.operation.value = filteredOperationsForItem[0].name;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true,
            filteredOperations: detailPageState.filteredOperations
        });
    }

    const onOperationChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        element.operation.value = newValue;
        element.operation.error = null;
        detailPageState.studyActivityDetails[index] = element;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true
        });
    }

    const onElementCategoryChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        element.elementCategory.value = newValue;
        element.elementCategory.error = null;
        detailPageState.studyActivityDetails[index] = element;

        let selectedElementCategory = dropDownData.elementCategories.find(x => x.id == newValue)?.name
        let filteredElementNamesForItem = dropDownData.elementName.filter(x => x.categoryName?.toUpperCase() == selectedElementCategory.toUpperCase());
        detailPageState.filteredElementNames[index] = filteredElementNamesForItem;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true,
            filteredElementNames: detailPageState.filteredElementNames
        });
    }

    const onElementNameChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        element.element.value = newValue;
        element.element.error = null;
        detailPageState.studyActivityDetails[index] = element;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true
        });
    }

    const onSubDescriptionChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        element.elementSubDescription.value = newValue;
        element.elementSubDescription.error = null;
        detailPageState.studyActivityDetails[index] = element;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true
        });
    }

    const onGSDValueChange = (newValue, index) => {
        var element = detailPageState.studyActivityDetails[index];
        element.gsdValue.value = newValue;
        element.gsdValue.error = null;
        detailPageState.studyActivityDetails[index] = element;

        setdetailPageState({
            ...detailPageState,
            studyActivityDetails: [...detailPageState.studyActivityDetails],
            isAnyRecordEdited: true
        });
    }

    const validateStudyActivityDetails = async (studyActivityDetails) => {
        let isValid = true;
        studyActivityDetails = await Promise.all(studyActivityDetails.map(async element => {
            let [validatedElement, isValidElement]: any = await utilFunctions.validateFormData(element);
            if (!isValidElement) {
                isValid = false;
            }
            return validatedElement;
        }));
        return [studyActivityDetails, isValid];
    }

    return (
        <>
            <TableContainer>
                <Table size="small" stickyHeader className={`appTable ${styles.preStudyDetailGrid}`}>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={{ sizeSmall: styles.preActiveGSDCode }}>GSD Code</TableCell>
                            <TableCell classes={{ sizeSmall: styles.preActiveOperations }}>Operation</TableCell>
                            <TableCell classes={{ sizeSmall: styles.preActiveCategory }}>Element Category</TableCell>
                            <TableCell classes={{ sizeSmall: styles.preActiveElement }}>Main Element</TableCell>
                            <TableCell classes={{ sizeSmall: styles.preActiveDescription }}>Sub Description</TableCell>
                            <TableCell classes={{ sizeSmall: styles.preActiveGSDValue }}>GSD Value</TableCell>
                            <TableCell className={styles.preStudyDetailGridAction}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {console.log(detailPageState?.studyActivityDetails, "study details")}
                        {detailPageState?.studyActivityDetails?.slice(detailPageState.page * detailPageState.rowsPerPage, detailPageState.page * detailPageState.rowsPerPage + detailPageState.rowsPerPage)
                            .map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell classes={{ sizeSmall: styles.preActiveGSDCode }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.gsdCode?.isRequired}>
                                                <GSDCodeSelect
                                                    gsdCodes={ddData?.gsdCodes}
                                                    error={!!item.gsdCode.error}
                                                    selectedValue={item.gsdCode.value}
                                                    disabled={!item.inEditMode}
                                                    onGSDCodeChange={(value) => { onGSDCodeChange(value, index) }}
                                                />
                                            </FormControlWrapper>

                                        </TableCell>
                                        <TableCell classes={{ sizeSmall: styles.preActiveOperations }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.operation?.isRequired}>
                                                <OperationSelect
                                                    operations={detailPageState?.filteredOperations[index]}
                                                    error={!!item.operation.error}
                                                    selectedValue={item.operation.value}
                                                    disabled={!item.inEditMode}
                                                    onOperationChange={(value) => { onOperationChange(value, index) }}
                                                />
                                            </FormControlWrapper>
                                        </TableCell>
                                        <TableCell classes={{ sizeSmall: styles.preActiveCategory }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.elementCategory?.isRequired}>
                                                <ElementCategorySelect
                                                    elementCategories={ddData?.elementCategories}
                                                    error={!!item.elementCategory.error}
                                                    selectedValue={item?.elementCategory.value}
                                                    disabled={!item.inEditMode}
                                                    onElementCategoryChange={(value) => { onElementCategoryChange(value, index) }}
                                                />
                                            </FormControlWrapper>
                                        </TableCell>
                                        <TableCell classes={{ sizeSmall: styles.preActiveElement }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.element?.isRequired}>
                                                <ElementNameSelect
                                                    elementNames={detailPageState?.filteredElementNames[index]}
                                                    error={!!item.element.error}
                                                    selectedValue={item.element.value}
                                                    disabled={!item.inEditMode}
                                                    onElementNameChange={(value) => { onElementNameChange(value, index) }}
                                                />
                                            </FormControlWrapper>
                                        </TableCell>
                                        <TableCell classes={{ sizeSmall: styles.preActiveDescription }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.elementSubDescription?.isRequired}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error={!!item.elementSubDescription.error}
                                                    value={!!item.elementSubDescription.value ? item.elementSubDescription.value : ''}
                                                    onChange={(event) => { onSubDescriptionChange(event.target.value, index) }}
                                                    type="text"
                                                    disabled={!item.inEditMode}
                                                />
                                            </FormControlWrapper>
                                        </TableCell>
                                        <TableCell classes={{ sizeSmall: styles.preActiveGSDValue }}>
                                            <FormControlWrapper label="" variant="block" isRequired={item.gsdValue?.isRequired}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error={!!item.gsdValue.error}
                                                    value={item.gsdValue.value}
                                                    onChange={(event) => { onGSDValueChange(event.target.value, index) }}
                                                    type="number"
                                                    disabled={!item.inEditMode}
                                                    InputProps={{
                                                        inputProps: {
                                                            step: "any",
                                                            min: 0
                                                        }
                                                    }
                                                    }
                                                    className={styles.preStudyGSDValue}
                                                />
                                            </FormControlWrapper>
                                        </TableCell>
                                        <TableCell className={styles.preStudyDetailGridAction}>
                                            {item.showEditButton && (
                                                <a className={'textPrimary iconMarginRight'} onClick={() => onEditButtonClick(index)}>
                                                    <EditIcon className="vAlignMiddle" />Edit
                                                </a>
                                            )}

                                            {item.showSaveButton && (
                                                <a className={'textPrimary iconMarginRight'} onClick={() => onSaveButtonClick(index, item)}>
                                                    <SaveIcon className="vAlignMiddle" />Save
                                                </a>
                                            )}
                                            {index != 0 && item.showDeleteButton && (
                                                <a className={'textRed'} onClick={() => onDeleteButtonClick(index)}>
                                                    <RemoveCircleIcon className="vAlignMiddle" />Delete
                                                </a>
                                            )}
                                            {index == 0 && (
                                                <a className={'textPrimary iconMarginRight'} onClick={() => onAddClick()}>
                                                    <AddCircleIcon className="vAlignMiddle" />Add
                                                </a>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        {(detailPageState?.studyActivityDetails?.length == 0) ? <TableRow><TableCell colSpan={props.isWebview ? 6 : 7}> No data found.</TableCell></TableRow> : null}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={APP_TABLE_SETTINGS.DEFAULT_ROWS_PER_PAGE}
                    component="div"
                    count={detailPageState?.studyActivityDetails.length}
                    rowsPerPage={detailPageState.rowsPerPage}
                    page={detailPageState.page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </TableContainer>
            {detailPageState.isAnyRecordEdited && detailPageState.studyActivityDetails != null && detailPageState.studyActivityDetails.length > 0 &&
                <div className="saveButtonBottom"><Button variant="contained" color="primary" onClick={() => { onSave() }}>Save Details</Button></div>}
        </>
    )
}

PreStudyActivityDetail.propTypes = {
    onSave: PropTypes.func,
    pageState: PropTypes.string,
    preStudyHeader: PropTypes.any,
    studyPreActivityDetails: PropTypes.any,
    dropDownData: PropTypes.any,
    onEdit: PropTypes.func,
    isWebview: PropTypes.bool,
}

export default PreStudyActivityDetail; 